import template from './trip-change-ticket.html';
import changeTicketModalTemplate from './trip-change-ticket-modal.html';
import changeTicketNotEligibleModal from './trip-change-ticket-not-eligible.html';

export const RAIL_GROUP_STATUSES = {
    OK: 0,
    ADVANCE_TYPE: 1,
    NOT_ADVANCE_TYPE: 2,
    ALREADY_AMENDED: 3,
    LACK_OF_TIME: 4,
    LACK_OF_PRICE: 5,
    REJECTED_BY_TL_API: 6,
    NOT_READY: 7,
};

export const ELIGIBILITY_STATUS = {
    OK: 0,
    NotReady: 1,
    NotEligible: 2,
};

const DIRECTIVE_NAME = TripChangeTicket.DIRECTIVE_NAME = 'ktTripChangeTicket';
export default function TripChangeTicket() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripChangeTicketController,
        controllerAs: '$ctrl',
        scope: {
            railRecommendation: `=${DIRECTIVE_NAME}`,
            trip: `=${DIRECTIVE_NAME}Trip`,
            travellersCount: `=${DIRECTIVE_NAME}TravellersCount`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripChangeTicketController(
    $scope,
    $rootScope,
    userService,
    modalService,
    railAmendmentService,
    tripChangeTicketService,
    tripItemRailGroupService,
    tripItemRailRecommendationService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        openChangeTicketModal,
        checkJourneyChangeEligibility,

        navigateToSearchForm,
        isFirstClass: tripChangeTicketService.isFirstClass,
        getFirstStop: tripChangeTicketService.getFirstStop,
        getLastStop: tripChangeTicketService.getLastStop,

        getGroupTicketsPrice: tripItemRailGroupService.getGroupTicketsPrice,
        isDirectionOutward: tripItemRailGroupService.isDirectionOutward,
        isDirectionReturn: tripItemRailGroupService.isDirectionReturn,

        isDirectionRoundtrip: tripItemRailRecommendationService.isDirectionRoundtrip,
        isDirectionOneway: tripItemRailRecommendationService.isDirectionOneway,

        railGroupStatuses: {},
        RAIL_GROUP_STATUSES,
        continueButtonDisabled,
        moment,
    });

    function $onInit() {
        vm.readOnlyMode = $rootScope.readOnlyMode;
        [vm.selectedRailGroup] = vm.railRecommendation.RailGroups;
        vm.regionalSettings = userService.getRegionalSettings();
        vm.isItemCanBeAmended = !vm.trip.ApprovalSettings.IsApprovalRequired && tripChangeTicketService.isItemCanBeAmended(vm.railRecommendation);
        vm.amendmentTooltipText = tripChangeTicketService.getTooltipTextById(vm.railRecommendation.CanBeAmended);

        $scope.$watch(() => vm.selectedRailGroup, updateSelectedRailGroupStatus);
    }

    function checkJourneyChangeEligibility() {
        railAmendmentService.getJourneyEligibility(vm.railRecommendation.Id, vm.trip.Id)
            .then(({Eligibility, railGroupStatuses}) => {
                setRailGroupStatuses(railGroupStatuses);
                return Eligibility === ELIGIBILITY_STATUS.OK
                    ? openChangeTicketModal()
                    : openChangeTicketUnavailabilityModal();
            });
    }

    function openChangeTicketModal() {
        modalService.openModal({
            template: changeTicketModalTemplate,
            scope: $scope,
        });
    }

    function openChangeTicketUnavailabilityModal() {
        modalService.openModal({
            template: changeTicketNotEligibleModal,
            scope: $scope,
        });
    }

    function setRailGroupStatuses(railGroupStatuses) {
        Object.assign(vm, {railGroupStatuses});
        updateSelectedRailGroupStatus();
    }

    function updateSelectedRailGroupStatus() {
        vm.selectedRailGroupStatus = vm.selectedRailGroup
            && vm.railGroupStatuses
            && vm.railGroupStatuses[vm.selectedRailGroup.Id];
    }

    function continueButtonDisabled() {
        return vm.form.$invalid
            || ![RAIL_GROUP_STATUSES.OK, RAIL_GROUP_STATUSES.ADVANCE_TYPE].includes(vm.selectedRailGroupStatus);
    }

    function navigateToSearchForm() {
        vm.form.$setSubmitted();
        if (vm.form.$invalid) {
            return;
        }

        const groupTicketsPrice = tripItemRailGroupService.getGroupTicketsPrice(vm.selectedRailGroup);
        const {selectedRailGroup: railGroup, areTicketsCollected, railRecommendation, travellersCount} = vm;
        const tripId = vm.trip.Id;
        const params = {
            railGroup,
            areTicketsCollected,
            railRecommendation,
            tripId,
            groupTicketsPrice,
            travellersCount,
        };
        tripChangeTicketService.navigateToSearchForm(params);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket-component.js